import CoordinatesLocation from './CoordinatesLocation'

interface DropOffLocationFromJson {
  location_address: string
  name: string
  phone_number: string
  location: CoordinatesLocation
  information: string|null
}

class DropOffLocation {
  address: string
  name: string
  phone: string
  position: CoordinatesLocation
  information: string|null

  constructor (address: string, name: string, phone: string, lat: string, lng: string, information: string|null) {
    this.address = address
    this.name = name
    this.phone = phone
    this.position = {
      lat,
      lng
    }
    this.information = information
  }

  static fromJson ({ location_address, name, phone_number, location, information }: DropOffLocationFromJson) {
    return new DropOffLocation(location_address, name, phone_number, location.lat, location.lng, information)
  }
}

export default DropOffLocation
